import React from 'react';
import { PointExpireLogDetailContainerStyled } from './styled';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import { Buttons, Displays, Inputs } from 'components';
import { AlertControl } from 'components/Modals/Alert';
import {
  formatDate,
  formatDateTime,
  formatPoint,
  RENDER_LOG_STATUS,
  RENDER_LOT_LABEL,
  RENDER_RUN_STATUS,
  RENDER_TRIGGER,
} from 'utils/functions/pointExpire';

const hasValue = (value) => value !== undefined && value !== null;

// รายละเอียดรายการตัดแต้ม 1 รายการ + ปุ่มซ่อมรายการที่ค้าง processing (void / complete)
class PointExpireLogDetailContainer extends React.Component {
  state = {
    isLoading: true,
    isBgLoading: false,
    data: null,
    reason: '',
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { id } = this.props;
    let res = await portalService.GET_POINT_EXPIRE_LOG_DETAIL(id);
    if (res && res.status === 200) {
      this.setState({ data: res.data, isLoading: false });
    } else {
      toast.error('ไม่พบข้อมูล');
      this.setState({ isLoading: false });
    }
  };

  // action: 'void' = ยังไม่ได้หัก wallet ยกเลิกรายการให้รอบถัดไปคำนวณใหม่
  //         'complete' = หัก wallet แล้วแต่ยังไม่มีประวัติ สร้างประวัติให้ครบ
  handleClickRepair = (action) => {
    const { reason } = this.state;
    if (!reason.trim()) {
      toast.error('กรุณาระบุเหตุผล');
      return;
    }
    const isVoid = action === 'void';
    AlertControl.show({
      title: isVoid ? 'ยืนยันยกเลิกรายการนี้?' : 'ยืนยันสร้างประวัติให้ครบ?',
      description: isVoid
        ? 'รายการจะถูกยกเลิก (ไม่หัก wallet) และรอบตัดแต้มถัดไปจะคำนวณลูกค้ารายนี้ใหม่'
        : 'ระบบจะสร้างแถว "คะแนนหมดอายุ" ในประวัติลูกค้าให้ตรงกับยอดที่หักไปแล้ว และปิดรายการเป็นสำเร็จ',
      btnLabel1: 'ยกเลิก',
      btnLabel2: 'ยืนยัน',
      onEvent2: () => this.handleRepair(action),
    });
  };

  handleRepair = async (action) => {
    const { data, reason } = this.state;
    const { onRepaired } = this.props;
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.setState({ isBgLoading: true });
    const params = { reason: reason.trim() };
    let res =
      action === 'void'
        ? await portalService.PUT_POINT_EXPIRE_LOG_VOID(data._id, params)
        : await portalService.PUT_POINT_EXPIRE_LOG_COMPLETE(data._id, params);
    this.isSubmitting = false;
    this.setState({ isBgLoading: false });
    if (res && res.status === 200) {
      toast.success(action === 'void' ? 'ยกเลิกรายการสำเร็จ' : 'สร้างประวัติสำเร็จ');
      // หลัง void backend จะพยายามรันตัดลูกค้ารายนี้ใหม่ทันที ผลอยู่ใน res.data.rerun
      // - run object (มี status) = รันแล้ว / - { error_message } = รันทันทีไม่ได้ (cron คืนถัดไปรันให้)
      // - null = ไม่มีอะไรต้องรัน
      const rerun = action === 'void' && res.data ? res.data.rerun : null;
      if (rerun && rerun.status) {
        toast.success(
          `ระบบรันตัดใหม่แล้ว สถานะ ${RENDER_RUN_STATUS(rerun.status)} ตัดสำเร็จ ${
            rerun.success_count || 0
          } คน`
        );
      } else if (rerun && rerun.error_message) {
        toast.warning(
          `ยกเลิกแล้ว แต่รันตัดใหม่ทันทีไม่ได้: ${rerun.error_message} (ระบบจะรันให้อัตโนมัติในคืนถัดไป)`
        );
      }
      onRepaired && onRepaired();
    } else {
      const message =
        (res && res.data && res.data.error && res.data.error.message) ||
        'ดำเนินการไม่สำเร็จ';
      toast.error(message);
    }
  };

  renderRow = (label, value) => (
    <div className="info_row">
      <div className="info_label">{label}</div>
      <div className="info_value">
        {value === undefined || value === null || value === '' ? '-' : value}
      </div>
    </div>
  );

  render() {
    const { onClose } = this.props;
    const { isLoading, isBgLoading, data, reason } = this.state;
    const run = data && data.run;
    const lots = (data && data.lots) || [];
    const isProcessing = data && data.status === 'processing';
    // ให้ backend เป็นคนตัดสินว่า "หัก wallet ไปแล้วหรือยัง" (ดูจาก wallet_point_after และ
    // ตราประทับ log id บน wallet ซึ่งหน้านี้มองไม่เห็น) ถ้ากดผิดฝั่ง API จะตอบ error บอกให้ใช้อีกปุ่ม
    const canVoid = isProcessing;
    const canComplete = isProcessing && !data.wallet_history_ref_id;

    return (
      <PointExpireLogDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="modal_head">
          <div className="modal_title">รายละเอียดการตัดแต้มหมดอายุ</div>
          <div className="close_btn" onClick={onClose}>
            ✕
          </div>
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="300px" />
        ) : !data ? (
          <div className="empty">ไม่พบข้อมูล</div>
        ) : (
          <>
            <div className="two_col">
              <div className="section">
                <div className="section_title">ข้อมูลรายการ</div>
                {this.renderRow(
                  'สถานะ',
                  <span className={`status_badge status_${data.status}`}>
                    {RENDER_LOG_STATUS(data.status)}
                  </span>
                )}
                {this.renderRow('Login ID', data.customer_user_id)}
                {this.renderRow('CU code', data.customer_cu_id)}
                {this.renderRow('ล็อต', RENDER_LOT_LABEL(data.period_key))}
                {this.renderRow('วันหมดอายุของล็อต', formatDate(data.expire_at))}
                {this.renderRow(
                  'วันที่ตัด',
                  formatDateTime(data.expired_run_at || data.created_at)
                )}
                {this.renderRow(
                  'ยอดไม่ตรง',
                  data.is_mismatch ? (
                    <span className="danger_text">
                      ใช่{data.mismatch_reason ? ` — ${data.mismatch_reason}` : ''}
                    </span>
                  ) : (
                    'ไม่'
                  )
                )}
              </div>
              <div className="section">
                <div className="section_title">ตัวเลข</div>
                {this.renderRow('ได้รับในล็อต', formatPoint(data.lot_received))}
                {this.renderRow('ใช้ไปจากล็อต', formatPoint(data.lot_redeemed))}
                {this.renderRow('คงเหลือในล็อต', formatPoint(data.lot_remaining))}
                {this.renderRow('ยอดตาม ledger', formatPoint(data.ledger_balance))}
                {this.renderRow('Wallet ก่อนตัด', formatPoint(data.wallet_point_before))}
                {this.renderRow(
                  'ยอดที่ตัด',
                  <b className="danger_text">{formatPoint(data.expired_point)}</b>
                )}
                {this.renderRow(
                  'Wallet หลังตัด',
                  hasValue(data.wallet_point_after)
                    ? formatPoint(data.wallet_point_after)
                    : 'ยังไม่ได้หัก'
                )}
              </div>
            </div>

            {data.error_message && (
              <div className="error_box">
                <div className="error_title">ข้อผิดพลาด</div>
                <div className="error_message">{data.error_message}</div>
              </div>
            )}

            {data.repair_action && (
              <div className="note_box">
                <b>ซ่อมโดยแอดมิน:</b> {data.repair_action}
                {data.repair_admin_username ? ` (${data.repair_admin_username})` : ''}
                {data.repair_reason ? ` — เหตุผล: ${data.repair_reason}` : ''}
              </div>
            )}

            {lots.length > 0 && (
              <div className="section">
                <div className="section_title">ยอดแยกตามล็อต ณ เวลาที่ตัด</div>
                <div className="table_wrap">
                  <table className="item_table">
                    <thead>
                      <tr>
                        <th>ล็อต</th>
                        <th className="right">ได้รับ</th>
                        <th className="right">ปรับเพิ่ม</th>
                        <th className="right">ใช้ไป</th>
                        <th className="right">ปรับลด</th>
                        <th className="right">ตัดหมดอายุแล้ว</th>
                        <th className="right">คงเหลือ</th>
                        <th>วันหมดอายุ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lots.map((e, i) => (
                        <tr key={i}>
                          <td>{RENDER_LOT_LABEL(e.key)}</td>
                          <td className="right">{formatPoint(e.received)}</td>
                          <td className="right">{formatPoint(e.adjusted_in)}</td>
                          <td className="right">{formatPoint(e.redeemed)}</td>
                          <td className="right">{formatPoint(e.adjusted_out)}</td>
                          <td className="right">{formatPoint(e.expired)}</td>
                          <td className="right bold">{formatPoint(e.remaining)}</td>
                          <td>{e.expire_at ? formatDate(e.expire_at) : 'ไม่หมดอายุ'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {run && (
              <div className="section">
                <div className="section_title">รอบตัดแต้ม</div>
                <div className="run_grid">
                  {this.renderRow(
                    'สถานะรอบ',
                    <span className={`status_badge status_${run.status}`}>
                      {RENDER_RUN_STATUS(run.status)}
                    </span>
                  )}
                  {this.renderRow('ตัดโดย', RENDER_TRIGGER(run.trigger))}
                  {this.renderRow('เริ่ม', formatDateTime(run.started_at))}
                  {this.renderRow('จบ', formatDateTime(run.finished_at))}
                  {this.renderRow('ลูกค้าทั้งหมด', formatPoint(run.customer_count))}
                  {this.renderRow('ที่จะตัด', formatPoint(run.expiring_customer_count))}
                  {this.renderRow('สำเร็จ / ไม่สำเร็จ', `${run.success_count || 0} / ${run.fail_count || 0}`)}
                  {this.renderRow('แต้มรวมที่ตัด', formatPoint(run.total_point))}
                  {run.admin_username && this.renderRow('แอดมิน', run.admin_username)}
                  {run.remark && this.renderRow('หมายเหตุ', run.remark)}
                  {run.error_message && this.renderRow('ข้อผิดพลาด', run.error_message)}
                </div>
              </div>
            )}

            {isProcessing && (
              <div className="repair_box">
                <div className="repair_title">รายการค้างดำเนินการ (processing)</div>
                <div className="repair_desc">
                  รายการนี้ถูกจองไว้แต่ทำไม่จบ (process อาจดับกลางคัน) ตรวจสอบแล้วเลือกวิธีซ่อม:
                  <br />• <b>ยกเลิกรายการ</b> — ใช้เมื่อยังไม่ได้หัก wallet (Wallet หลังตัดว่าง)
                  รอบถัดไปจะคำนวณลูกค้ารายนี้ใหม่
                  <br />• <b>สร้างประวัติให้ครบ</b> — ใช้เมื่อหัก wallet แล้วแต่ยังไม่มีประวัติ
                  (มี Wallet หลังตัด แต่ยังไม่มีแถว "คะแนนหมดอายุ" ในประวัติลูกค้า)
                </div>
                <Inputs.TextArea
                  label="เหตุผล (บังคับ)"
                  placeholder="ระบุเหตุผลที่ซ่อมรายการนี้"
                  value={reason}
                  onChange={(e) => this.setState({ reason: e.target.value })}
                />
                <div className="repair_action">
                  <div className="btn_box">
                    <Buttons.BgStandard
                      theme_red
                      label="ยกเลิกรายการ"
                      disabled={!canVoid || isBgLoading}
                      onClick={() => this.handleClickRepair('void')}
                    />
                  </div>
                  <div className="btn_box">
                    <Buttons.BgStandard
                      theme_green
                      label="สร้างประวัติให้ครบ"
                      disabled={!canComplete || isBgLoading}
                      onClick={() => this.handleClickRepair('complete')}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="action_zone">
              <div className="btn_box">
                <Buttons.BgStandard theme_gray label="ปิด" onClick={onClose} />
              </div>
            </div>
          </>
        )}
      </PointExpireLogDetailContainerStyled>
    );
  }
}

export default PointExpireLogDetailContainer;
